module.exports = __webpack_public_path__ + "static/media/sy_dummies_ppt_pic_3.f94d36bd.png";